<template>
  <service-screen-layout :parts="parts">
    <template v-slot:details>
        <div class="row">
            <div class="col-md-7">
                <div class="card-header" >
                    <h4>Service Details</h4>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Service ID: </label>
                                <input type="text" class="form-control col-md-12" v-model="saleDefinition.definition.layer3service.serviceId">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">IPV4 Range: </label>
                                <input type="text" class="form-control col-md-12"
                                v-model="saleDefinition.definition.layer3service.ipv4Range">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">IPV6 Range: </label>
                                <input type="text" class="form-control col-md-12"
                                v-model="saleDefinition.definition.layer3service.ipv6Range">
                            </div>
                        </div>
                    </div>
                    <div class="row" v-allowed:view="['STAFF']">
                        <div class="col-md-12">
                            <div class="form-group">
                                <button class="btn btn-success" @click="saveSale()" type="button">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class="card card-default">
                    <div class="card-header">
                        <h4>{{saleDefinition.definition.layer3service.servicePackage.description}}</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                Details:
                            </div>
                            <div class="col-md-8">
                                <strong>{{saleDefinition.definition.layer3service.servicePackage.toString}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-slot:regrade>
        <div class="row row-spacing">
          <div class="col-md-2">
            <h3>Regrade</h3>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-5">
                <label>Package</label>
                <div class="input-group">
                  <select class="form-control" v-model="packageSelected" :disabled="hasPending()">
                    <option
                      v-for="packy in availablePackages"
                      :key="packy.layer3PackageNumber"
                      :value="packy.layer3PackageNumber"
                    >
                      {{ packy.description }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-success" type="button" @click="immediateChangePackage()" :disabled="hasPending()">Immediate Regrade</button>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-success" type="button" @click="scheduleChangePackage()" :disabled="hasPending()">Schedule Regrade</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-spacing">
          <div class="col-md-12">
            <div class="table-bordered table-responsive">
              <table class="table">
                <thead>
                  <tr class="dark-row">
                    <th>Regrade To</th>
                    <th>Description</th>
                    <th>Created</th>
                    <th>Status</th>
                    <th>Scheduled</th>
                  </tr>
                </thead>
                <tbody v-if="packageChanges?.length > 0">
                  <tr v-for="packageChange in packageChanges" :key="packageChange.layer3ChangeInstructionNumber">
                    <td>{{ packageChange.layer3PackageNumber }} </td>  
                    <td>{{ packageChange.packageChange.description }}</td>
                    <td>{{ packageChange.created }}</td>
                    <td>{{ packageChange.status }}</td>
                    <td>{{ packageChange.billingPeriod }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8">No Regrades requested</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
    </template>
    <template v-slot:address>
        <div class="row">
            <div class="col-md-8">
                <div class="card-header" >
                    <h4>Address Details</h4>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Address Type: </label>
                                <v-select
                                    name="Address Type"
                                    label="description"
                                    valueProp="name"
                                    v-model="saleDefinition.definition.layer3service.serviceAddress.addressType"
                                    v-if="saleDefinition.product.productDefinition == 'OpenserveOfficeConnectService'"
                                    :options="saleDefinition.supportingEnums.OpenserveOfficeConnectAddress.addressType"
                                >
                                </v-select>
                                <v-select
                                    name="Address Type"
                                    label="description"
                                    valueProp="name"
                                    v-model="saleDefinition.definition.layer3service.serviceAddress.addressType"
                                    v-if="saleDefinition.product.productDefinition == 'LiquidBroadbandService'"
                                    :options="saleDefinition.supportingEnums.LiquidBroadbandAddress.addressType"
                                >
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="control-label">Sub Premise: </label>
                                <input type="text" class="form-control col-md-12"
                                v-model="saleDefinition.definition.layer3service.serviceAddress.subpremise">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="control-label">Street Number: </label>
                                <input type="text" class="form-control col-md-12"
                                v-model="saleDefinition.definition.layer3service.serviceAddress.streetNumber">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Street Name: </label>
                                <input type="text" class="form-control col-md-12"
                                v-model="saleDefinition.definition.layer3service.serviceAddress.streetName">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Suburb: </label>
                                <input type="text" class="form-control col-md-12"
                                v-model="saleDefinition.definition.layer3service.serviceAddress.suburb">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">City: </label>
                                <input type="text" class="form-control col-md-12"
                                v-model="saleDefinition.definition.layer3service.serviceAddress.city">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="control-label">Province: </label>
                                <select
                                    name="Province"
                                    class="form-control"
                                    v-model="saleDefinition.definition.layer3service.serviceAddress.province"
                                >
                                    <option value="Eastern Cape">Eastern Cape</option>
                                    <option value="Western Cape">Western Cape</option>
                                    <option value="Northern Cape">Northern Cape</option>
                                    <option value="North West">North West</option>
                                    <option value="Freestate">Freestate</option>
                                    <option value="Gauteng">Gauteng</option>
                                    <option value="KwaZulu-Natal">KwaZulu-Natal</option>
                                    <option value="Limpopo">Limpopo</option>
                                    <option value="Mpumalanga">Mpumalanga</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="control-label">Postal Code: </label>
                                <input type="text" class="form-control col-md-12"
                                v-model="saleDefinition.definition.layer3service.serviceAddress.postalCode">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label">Country: </label>
                                <select
                                    name="Country"
                                    class="form-control"
                                    v-model="saleDefinition.definition.layer3service.serviceAddress.country"
                                >
                                    <option value="South Africa">South Africa</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-allowed:view="['STAFF']">
                        <div class="col-md-12">
                            <div class="form-group">
                                <button class="btn btn-success" @click="saveSale()" type="button">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
  </service-screen-layout>
</template>

<script>
import SaleFunctions from "@/pages/Services/SaleFunctions";
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";

export default {
  extends: SaleFunctions,
  components: {
    ServiceScreenLayout,
  },
  data() {
    return {
      parts: [
        {
          name: "details",
          icon: "fa fa-info-circle",
          displayName: "Service",
          permissions: ["*"],
        },
        {
          name: "regrade",
          icon: "fa fa-arrows-v",
          displayName: "Regrade",
          permissions: ["*"],
        },
        {
          name: "address",
          icon: "fa fa-truck",
          displayName: "Address",
          permissions: ["*"],
        },
      ],
      saleDefinition: {
        definition: {
            layer3service: {
                serviceId: '',
                ipv4Range: '',
                ipv6Range: '',
                servicePackage: {},
                serviceAddress: {},
            },
        },
        product: {
            productDefinition: '',
        },
        supportingEnums: {
            OpenserveOfficeConnectAddress: {
                addressType: [],
            },
            LiquidBroadbandAddress: {
                addressType: [],
            }
        }
      },
      packages: [],
      availablePackages: [],
      packageSelected: null,
      packageChanges: [],
      period: this.getCurrentPeriod(),
    };
  },
  mounted() {
    this.loadSaleDefinition();
  },
  methods: {
    loadSaleDefinition() {
      const saleNumber = this.$route.params.saleNumber;
      this.getSaleDefinition(saleNumber).then(
        (success) => {
            this.saleDefinition = success.data;
            this.packageChanges = success.data.definition.layer3service.layer3ChangeInstructions
            this.availablePackages = success.data.selectableOptions.packageChange
            this.getPackages();
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Sale Definition", error);
        }
      );
    },
    getPackages() {
      this.$http.get(this.$config.aimsAPI + "pricing/packages/product/" + this.saleDefinition.product.productNumber + "/Layer3Package")
        .then(
          (response) => {
            this.packages = response.data;
          },
          (error) => {
            this.showError("Error fetching Layer3 Packages", error);
            console.error(error);
          }
        );
    },
    saveSale() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http
            .put(
              this.$config.aimsAPI +
                "sales/definition/" +
                this.saleDefinition.sale.saleNumber +
                "/update",
              this.saleDefinition
            )
            .then(
              (response) => {
                this.showSuccess("Save Success");
                this.saleDefinition = response.data;
              },
              (error) => {
                console.error(error);
                this.showError("Error Saving Sale Definition", error);
              }
            );
        }
      });
    },
    scheduleChangePackage: function () {
      if (this.packageSelected) {
        const packy = this.packages.find(
          (packy) => packy.layer3PackageNumber === this.packageSelected
        );
        const priceInclVAT = "Incl VAT " + this.getPrice(packy.prices, this.period, true);

        this.$swal({
          title: "Regrade effective 1st of next month?",
          text: priceInclVAT,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Regrade",
        }).then((result) => {
          if (result.value) {
            this.packageChange(packy, false);
          }
        });
      } else {
        this.showWarningAlert("Please select a Package to regrade to")
      }
    },
    immediateChangePackage: function () {
      if (this.packageSelected) {
        const packy = this.packages.find(
          (packy) => packy.layer3PackageNumber === this.packageSelected
        );
        const priceInclVAT = "Incl VAT " + this.getPrice(packy.prices, this.period, true);

        this.$swal({
          title: "Immediate Regrades will have additional billing for this month?",
          text: priceInclVAT,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Regrade",
        }).then((result) => {
          if (result.value) {
            this.packageChange(packy, true);
          }
        });
      } else {
        this.showWarningAlert("Please select a Package to regrade to")
      }
    },
    hasPending: function() {
      if (this.packageChanges != null) {
        for (const item of this.packageChanges) {
          if (item.status.toLowerCase().includes("pending".toLocaleLowerCase())) {
            return true;
          }         
        }
      }
      return false;   
    },
    packageChange: function (packageChange, immediate) {
      let changePackageInstruction = this.deepCopyObject(this.saleDefinition.supportingObjs.layer3ChangeInstructions);
      changePackageInstruction.liquidBroadbandNumber = this.saleDefinition.definition.layer3service.liquidBroadbandNumber;
      changePackageInstruction.layer3PackageNumber = packageChange.layer3PackageNumber;

      if (immediate) {
        changePackageInstruction.billingPeriod = this.getCurrentPeriod();
      } else {
        changePackageInstruction.billingPeriod = this.increaseBillingPeriod(this.getCurrentPeriod());
      }

      this.createObjPart(changePackageInstruction, true).then(
        (response) => {
          this.showSuccess("Regrade successfully submitted");
          this.loadSaleDefinition();
        },
        (error) => {
          console.error(error);
          this.showError("Error with Regrade Instruction", error);
        }
      );
    },
    getPrice(data, period, vat) {
      if (data) {
        if (data.length > 0) {
          let price = data.filter((price) => period >= price.validFrom);
          price.forEach((newPrice) => {
            if (newPrice.validUntil != 0) {
              price = price.filter((price) => period <= price.validUntil);
            } else {
              price = newPrice;
            }
          });
          if (Array.isArray(price)) {
            if (price.length > 0) {
              if (vat) {
                return this.timesVAT(
                  parseFloat(price[0].priceExclVat)
                );
              } else {
                return this.currencyFormat(
                  parseFloat(price[0].priceExclVat)
                );
              }
            } else {
              return "R " + 0;
            }
          } else {
            if (vat) {
              return this.timesVAT(
                parseFloat(price.priceExclVat)
              );
            } else {
              return this.currencyFormat(
                parseFloat(price.priceExclVat)
              );
            }
          }
        } else {
          return "R " + 0;
        }
      } else {
        return 0;
      }
    },
  },
};
</script>